(function () {
  'use strict';
  /* Transparent header: turn navy after scrolling past the top */
  var th = document.querySelector('[data-transparent-header]');
  if (th) {
    var start = th.offsetTop + th.offsetHeight;
    var onScroll = function () { th.classList.toggle('is-scrolled', window.scrollY > start); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Dropdown menus: hover/focus open via CSS; the chevron button toggles for touch and keyboard */
  var dds = document.querySelectorAll('[data-dropdown]');
  function closeAll(except) {
    dds.forEach(function (dd) {
      if (dd === except) return;
      dd.classList.remove('is-open');
      var b = dd.querySelector('[data-dropdown-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  dds.forEach(function (dd) {
    var btn = dd.querySelector('[data-dropdown-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = !dd.classList.contains('is-open');
      closeAll(dd);
      dd.classList.toggle('is-open', open);
      dd.classList.toggle('is-closed', !open);
      btn.setAttribute('aria-expanded', String(open));
    });
    dd.addEventListener('mouseleave', function () { dd.classList.remove('is-closed'); });
    dd.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        dd.classList.remove('is-open');
        dd.classList.add('is-closed');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
    dd.addEventListener('focusout', function (e) {
      if (!dd.contains(e.relatedTarget)) { dd.classList.remove('is-closed'); }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dropdown]')) closeAll(null);
  });

})();
